import {
  TimeSheetsAdjustmentsSliceStateType,
  TimeSheetsAdjustmentsSliceActionsType,
  createTimeSheetsAdjustment,
  loadTimeSheetsAdjustments,
  partialUpdateTimeSheetsAdjustment,
  resetTimeSheetsAdjustments,
} from 'src/store/organizationAdmin/timeSheetsAdjustmentsSlice';
import { useAppDispatch, useAppSelector } from 'src/hooks/useRedux';
import getFetchStatus from 'src/utils/fetchStatus';
import {
  CreateParams,
  IndexParams,
  PartialUpdateParams,
} from 'src/repositories/organizationAdmin/TimeSheetsAdjustmentsRepository';

type UseTimeSheetsAdjustmentsType = Pick<TimeSheetsAdjustmentsSliceStateType, 'timeSheetsAdjustments' | 'meta'> &
  TimeSheetsAdjustmentsSliceActionsType & {
    isTimeSheetsAdjustmentsFinished: boolean;
    isTimeSheetsAdjustmentPartialUpdatePending: boolean;
    isTimeSheetsAdjustmentCreatePending: boolean;
  };

const useTimeSheetsAdjustments = (): UseTimeSheetsAdjustmentsType => {
  const dispatch = useAppDispatch();
  const {
    meta,
    timeSheetsAdjustments,
    index: { fetchStatus: timeSheetsAdjustmentsIndexStatus },
    partialUpdate: { fetchStatus: timeSheetsAdjustmentPartialUpdateStatus },
    create: { fetchStatus: timeSheetsAdjustmentCreateStatus },
  } = useAppSelector(state => state.organizationAdminTimeSheetsAdjustments);

  const isTimeSheetsAdjustmentsFinished = getFetchStatus(timeSheetsAdjustmentsIndexStatus).isFinished;
  const isTimeSheetsAdjustmentPartialUpdatePending = getFetchStatus(timeSheetsAdjustmentPartialUpdateStatus).isPending;
  const isTimeSheetsAdjustmentCreatePending = getFetchStatus(timeSheetsAdjustmentCreateStatus).isPending;

  return {
    meta,
    timeSheetsAdjustments,
    isTimeSheetsAdjustmentsFinished,
    isTimeSheetsAdjustmentPartialUpdatePending,
    isTimeSheetsAdjustmentCreatePending,
    loadTimeSheetsAdjustments: (params?: IndexParams) => dispatch(loadTimeSheetsAdjustments(params)),
    partialUpdateTimeSheetsAdjustment: (params: PartialUpdateParams) =>
      dispatch(partialUpdateTimeSheetsAdjustment(params)),
    createTimeSheetsAdjustment: (params: CreateParams) => dispatch(createTimeSheetsAdjustment(params)),
    resetTimeSheetsAdjustments: () => dispatch(resetTimeSheetsAdjustments()),
  };
};

export default useTimeSheetsAdjustments;
